import type { RxBucket } from "cruzo";

export const DEMO_MODAL_ID = "modal_demo";

export const demoModalScope = {
  bucket: null as RxBucket<any> | null,
};
